// Detect contact info in questions/answers (anti-disintermediation). Mirrors the
// backend check in server.py; the backend is the authoritative enforcement.
const CONTACT_REGEXES = [
  /[\w.+-]+@[\w-]+\.[a-z]{2,}/i,                                  // full email
  /@[A-Za-z0-9_]{2,}/i,                                           // @handle / partial email
  /(https?:\/\/|www\.)/i,                                         // url
  /[\w-]+\.(com|net|org|io|me|app|xyz|hk|tw|cn|co)\b/i,           // domain
  /\+?\d[\d\s-]{6,}\d/,                                           // phone (8+ digits)
  /(微信|wechat|weixin|\bvx\b|v信|扣扣|whatsapp|whats\s*app|telegram|signal|skype|\bqq\b|instagram|\big\b|facebook|\bfb\b|抖音|小红书|小紅書|微博|電報|\bline\b|\bwx\b)/i,
  /(電話|手提|手機|手机|電郵|電子郵|電子郵件|e-?mail|\bmail\b|gmail|hotmail|outlook|yahoo|icloud|聯絡方式|联系方式|聯繫方式|加我|搵我|揾我|留低聯絡)/i,
];

// Normalize before scanning so evasions (full-width chars, spacing, Chinese-digit
// phone numbers) don't slip past the regexes above. Mirrors _normalize_for_scan in
// the backend.
const CN_DIGITS = { '零': '0', '〇': '0', '一': '1', '二': '2', '三': '3', '四': '4', '五': '5', '六': '6', '七': '7', '八': '8', '九': '9' };
const CN_DIGIT_RUN = /[零〇一二三四五六七八九]{7,}/g;   // only long runs -> avoid "一兩件事"
const SEP_RE = /[\s.\-_·•‧・,，。、丨|/\\*~#]+/g;

function normalizeForScan(text) {
  let t = String(text)
    .replace(/[！-～]/g, (c) => String.fromCharCode(c.charCodeAt(0) - 0xFEE0))  // full-width -> ASCII
    .replace(/　/g, ' ')                                                            // full-width space
    .toLowerCase();
  return t.replace(CN_DIGIT_RUN, (m) => m.replace(/./g, (c) => CN_DIGITS[c] || c));
}

export function hasContactInfo(text) {
  if (!text) return false;
  const norm = normalizeForScan(text);
  const compact = norm.replace(SEP_RE, '');   // defeats "微 信" / "9 8 7 6 5 4 3 2"
  return CONTACT_REGEXES.some((rx) => rx.test(norm) || rx.test(compact));
}
